import { useContentful } from '~~/composables/useContentful'
import query from '~/graphql/live-event'

export const useLiveEventStore = defineStore({
  id: 'liveEventStore',
  state: () => ({
    liveEvent: null,
    fetching: false,
  }),

  actions: {
    async fetchLiveEvent() {
      const contentful = useContentful()

      if (this.fetching === true) {
        return
      }
      this.fetching = true

      const response = await contentful.graphql(query)
      const json = await response.json()

      this.liveEvent = json.data.liveEventCollection.items?.[0]
    },
  },
})
